class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.render();
    this.startTimer();
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseEndTimeEST(str) {
    // Parse the date string and interpret it as EST/EDT (America/New_York timezone)
    // This automatically handles daylight saving time transitions
    
    // Remove any timezone indicators from the string first
    let cleanStr = str.trim().replace(/\s*(EST|EDT|ET)\s*$/i, '');
    
    // Create a date object from the string
    const date = new Date(cleanStr);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.error('Invalid date format:', str);
      return Date.now(); // fallback to now
    }
    
    // Get the date components
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    
    // Create a date string in ISO format but specify EST timezone
    // We'll use toLocaleString to convert to EST and then parse back
    const estDateString = new Date(year, month, day, hours, minutes, seconds)
      .toLocaleString('en-US', { 
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    
    // Parse the EST string back to get the correct UTC timestamp
    // The input date is ALREADY in EST, so we need to interpret it as such
    const estDate = new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    
    // Calculate the offset difference
    const localDate = new Date(date.toLocaleString('en-US'));
    const offset = estDate.getTime() - localDate.getTime();
    
    // Return the correct UTC timestamp
    return date.getTime() - offset;
  }

  startTimer() {
    const endTimeAttr = this.getAttribute('data-endtime');
    if (!endTimeAttr) return;

    const endTime = this.parseEndTimeEST(endTimeAttr);

    this.interval = setInterval(() => {
      const now = Date.now();
      let timeLeft = Math.floor((endTime - now) / 1000);

      if (timeLeft <= 0) {
        clearInterval(this.interval);
        this.innerHTML = `<span class="expired">00<span>DAYS</span></span>
                          <span class="expired">00<span>HRS</span></span>
                          <span class="expired">00<span>MIN</span></span>
                          <span class="expired">00<span>SEC</span></span>`;
        return;
      }

      const days = String(Math.floor(timeLeft / 86400)).padStart(2, '0');
      timeLeft %= 86400;
      const hours = String(Math.floor(timeLeft / 3600)).padStart(2, '0');
      timeLeft %= 3600;
      const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
      const seconds = String(timeLeft % 60).padStart(2, '0');

      this.innerHTML = `
        <span id="days">${days}<span class="count-text">DAYS</span></span>
        <span id="hours">${hours}<span class="count-text">HRS</span></span>
        <span id="minutes">${minutes}<span class="count-text">MIN</span></span>
        <span id="seconds">${seconds}<span class="count-text">SEC</span></span>
      `;
    }, 1000);
  }

  render() {
    this.style.display = 'inline-flex';
    this.innerHTML = `Loading...`;
  }
}

customElements.define('countdown-timer', CountdownTimer);